import { ApprovalStep } from './approval-step.model';
import { GeoDsMeta } from './meta-data.model';
export class ApprovalRequest extends GeoDsMeta{
    Description?: string;
    RequestedDate?: string;
    Status: string;
    Subject: string;
    IdRefApprovalProcessLib?:string;
    IdRefRequestedBy?:string;
    ParentId:string;
    ApprovalSteps?: ApprovalStep[];
    constructor(data) {
        super();
        Object.assign(this, data);
    }
}